export default "__VITE_PUBLIC_ASSET__2c87724f__"